// extracted by mini-css-extract-plugin
export var tableTitle = "bd_dq";